const CONTRAST_WORDS = {
  en: {
    personality: { high: 'high', low: 'low', moderate: 'moderate' },
    interest: { high: 'high', low: 'low', moderate: 'moderate' },
  },
  nb: {
    personality: { high: 'høyt', low: 'lavt', moderate: 'moderat' },
    interest: { high: 'høy', low: 'lav', moderate: 'moderat' },
  },
}

const getContrastWord = (level, type, language) =>
  CONTRAST_WORDS[language]?.[type]?.[level] || CONTRAST_WORDS.en[type][level]

export const formatDominantPattern = ({
  factor,
  score,
  area,
  interestScore,
  language = 'en',
}) => {
  if (!factor || !area) {
    return language === 'nb'
      ? 'Gå gjennom den høyeste personlighetsfaktoren og det høyeste interesseområdet sammen i samtalen.'
      : 'Review the highest personality factor and highest interest area together in the session.'
  }

  if (language === 'nb') {
    return `${factor} (${score}%) er den høyeste personlighetsfaktoren, og ${area} (${interestScore}) er det høyeste interesseområdet.`
  }

  return `${factor} (${score}%) is the highest personality factor, and ${area} (${interestScore}) is the highest interest area.`
}

export const formatWatchFor = ({
  factor,
  score,
  area,
  interestScore,
  language = 'en',
}) => {
  if (!factor || !area) {
    return language === 'nb'
      ? 'Gå gjennom den laveste personlighetsfaktoren og det laveste interesseområdet sammen i samtalen.'
      : 'Review the lowest personality factor and lowest interest area together in the session.'
  }

  if (language === 'nb') {
    return `${factor} (${score}%) er den laveste personlighetsfaktoren, og ${area} (${interestScore}) er det laveste interesseområdet.`
  }

  return `${factor} (${score}%) is the lowest personality factor, and ${area} (${interestScore}) is the lowest interest area.`
}

export const formatKeyContrast = ({
  area,
  personalityScore,
  interestScore,
  personalityLevel,
  interestLevel,
  language = 'en',
}) => {
  if (!area) {
    return language === 'nb'
      ? 'Se etter kontraster mellom personlighets- og interessescore som kan være verdt å utforske nærmere i samtalen.'
      : 'Look for contrasts between personality and interest scores that may be worth exploring in the session.'
  }

  const personalityWord = getContrastWord(
    personalityLevel,
    'personality',
    language,
  )
  const interestWord = getContrastWord(interestLevel, 'interest', language)

  if (language === 'nb') {
    return `Talentområdet ${area} er svært ${personalityWord} (personlighet: ${personalityScore}), mens uttrykt interesse er svært ${interestWord} (${interestScore}). Denne kontrasten kan være verdt å utforske nærmere.`
  }

  return `${area} is very ${personalityWord} (Personality: ${personalityScore}), while expressed interest is very ${interestWord} (${interestScore}). This contrast may be worth exploring further.`
}
